var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTdesignSavingPotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4986_5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.802 22.4983H5.198L4.41 18.9543C3.09 18.3683 1.444 17.3513 0.295 16.2083L0 15.9143V8.49928H1.934L2.887 6.90928L1.639 3.78928L2.773 3.52428C3.887 3.26628 5.343 3.33128 6.767 4.11628L6.787 4.10528C7.02189 3.96506 7.25926 3.82904 7.499 3.69728C7.98613 3.42243 8.48824 3.17505 9.003 2.95628C9.46 2.77128 9.895 2.61628 10.317 2.48828C9.75891 4.10814 9.86295 5.88283 10.6065 7.42639C11.35 8.96994 12.6729 10.1575 14.2874 10.7308C15.9019 11.3042 17.6775 11.2169 19.228 10.4879C20.7785 9.75897 21.9785 8.44734 22.567 6.83828L22.66 6.99828C25.125 11.2663 24.085 16.5943 20.434 19.6553L19.802 22.4993H14.198L13.753 20.4993H11.247L10.802 22.4983ZM4.5 11.4983H6.504V9.49428H4.5V11.4983Z",
    fill: "#FAA54B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C17.6935 0 18.8381 0.474106 19.682 1.31802C20.5259 2.16193 21 3.30653 21 4.5C21 5.69347 20.5259 6.83807 19.682 7.68198C18.8381 8.52589 17.6935 9 16.5 9C15.3065 9 14.1619 8.52589 13.318 7.68198C12.4741 6.83807 12 5.69347 12 4.5C12 3.30653 12.4741 2.16193 13.318 1.31802C14.1619 0.474106 15.3065 0 16.5 0Z",
    fill: "#FAA54B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4986_5293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdesignSavingPotFilled);
export default __webpack_public_path__ + "static/media/tdesign_saving-pot-filled.3beccde8fdd5f7c4005737087d800b90.svg";
export { ForwardRef as ReactComponent };